import axiosInstance from '@/services/axiosInstance'
// import mock from '@/services/mock/index'

async function retryCourtesyDaysAEAT (payload = {}) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      resolve()
    })
  } else {
    const req = {
      url: '/api/cifsempresa/reintentarsolicitudvacacionesmultiple',
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      data: payload
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { retryCourtesyDaysAEAT }
